import { defineMessages } from 'react-intl';

const errors = defineMessages({
    pleaseContactUs: {
        id: 'global.error.pleaseContactUs',
        defaultMessage: `Please contact us using below details.`,
    },
    someThingWrong: {
        id: 'global.error.someThingWrong',
        defaultMessage: `Oops, something went wrong.`,
    },
    defaultErrorDescription: {
        id: 'global.error.defaultErrorDescription',
        defaultMessage:
            'Something went wrong and we could not complete your request. Please return home and try again.',
    },
    defaultErrorButton: {
        id: 'global.error.defaultErrorButton',
        defaultMessage: 'Back to home',
    },
});

export default errors;
